import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

// import $ from "jquery"; //make sure you have jquery as dependency in package.json

import closeX from '../../images/clear-field-icon_white.png';
import chatLogo from '../../images/chat_logo.png';
import micDefault from '../../images/micDefault.png';
import micImg from '../../images/mic.png';
import tickImg from '../../images/chat-tick.png';
import sendImg from '../../images/send-icon.png';

import * as urls from './../../actions/urlTypes';

import * as messages from './../../messages/ChatbotMessages';

let recognition;
let inputElement = null;
let botElement = null;

export default class ChatBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputInFocus: false,
      micImage: micImg,
    };
    this.handleEnter = this.handleEnter.bind(this);
    // this.accessToken = urls.CHATBOT_TOKEN;
  }

  componentDidMount() {
    const inputnode = ReactDOM.findDOMNode(inputElement);
    const addEvent = inputnode.addEventListener || inputnode.attachEvent;

    addEvent('keypress', this.handleEnter, false);
    const data = {
      id: '653c1d4c-91c2-4ba9-9a89-a4aea80bb37b',
      timestamp: '2018-03-29T12:57:11.86Z',
      lang: 'en',
      result: {
        source: 'agent',
        resolvedQuery: 'Hispanic',
        action: 'demo-to-execute',
        actionIncomplete: false,
        parameters: { O: ['HISPANCY'], Operator: [] },
        contexts: [
          {
            name: 'c_2',
            parameters: {
              Operator: [],
              'O.original': 'Hispanic',
              'Operator.original': '',
              O: ['HISPANCY'],
            },
            lifespan: 1500,
          },
          {
            name: 'c_1',
            parameters: {
              Operator: [],
              'name.original': 'Nataraj',
              'O.original': 'Hispanic',
              name: 'Nataraj',
              'Operator.original': '',
              O: ['HISPANCY'],
            },
            lifespan: 1499,
          },
        ],
        metadata: {
          intentId: 'a7bfccac-1a7f-4ed7-ac37-5aa3813ce833',
          webhookUsed: 'true',
          webhookForSlotFillingUsed: 'true',
          webhookResponseTime: 1293,
          intentName: 'what-should-i-do',
        },
        fulfillment: {
          speech:
            `Hello, my name is Simmons!\nNeed a stat? Try asking me questions like,
            "How many people are married?"`,
          displayText:
            `Hello, my name is Simmons!\nNeed a stat? Try asking me questions like,
            "How many people are married?"`,
          messages: [
            {
              type: 0,
              speech:
                'There are 38.6 million adults in the U.S. that are Hispanic',
            },
          ],
        },
        score: 1,
      },
      status: { code: 200, errorType: 'success', webhookTimedOut: false },
      sessionId: 'somerandomthing',
    };

    this.setResponse(JSON.stringify(data, 'undefined', 2));
  }

  componentWillUnmount() {
    const inputnode = ReactDOM.findDOMNode(inputElement);
    const removeEvent = inputnode.removeEventListener || inputnode.detachEvent;
    // Reduce any memory leaks
    removeEvent('keypress', this.handleEnter);
  }

  send = () => {
    const text = inputElement.value;
    if (inputElement.value === '') {
      return;
    }
    let d = botElement.innerHTML;

    botElement.innerHTML = `${d.replace(
      '',
      '',
    )}
    <div class='calloutbig'><img src='${tickImg}' 
      width='45px' height='45px' class='chatick' style='float: right;' />
    <div class='calloutleft'>${text}</div><div class='clear'></div></div>`;

    axios({
      // url: `${urls.CHAT_BOT_URL}query?v=${urls.CHATBOT_VERSION}`,
      method: 'post',
      headers: { Authorization: `Bearer ${this.accessToken}` },
      withCredentials: true,
      responseType: 'json',
      data: {
        query: text,
        lang: 'en',
        sessionId: 'somerandomthing',
      },
    })
      .then(response => {
        this.setResponse(JSON.stringify(response.data, 'undefined', 2));
        inputElement.value = '';
        this.respond(response.data.result.fulfillment.speech);
      })
      .catch(() => {
        this.respond(messages.messageInternalError);
        this.setResponse('Internal Server Error');
      });

    // console.log("made ajax call..");
    // inputElement.value = "";

    d = botElement.lastElementChild.innerHTML;
    botElement.lastElementChild.innerHTML = [
      d.slice(0, 23),
      '',
      d.slice(23),
    ].join('');

    const objDiv = botElement;
    objDiv.scrollTop = objDiv.scrollHeight;
  };

  handleRec = () => {
    this.switchRecognition();
  };

  sendButonClick = () => {
    this.send();
  };

  switchRecognition = () => {
    if (recognition) {
      this.stopRecognition();
    } else {
      this.startRecognition();
    }
  };

  startRecognition = () => {
    recognition = new webkitSpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onstart = () => {
      this.respond(messages.messageRecording);
      this.updateRec();
    };

    recognition.onresult = event => {
      if (recognition) {
        recognition.onend = null;
      }
      let text = '';
      for (let i = event.resultIndex; i < event.results.length; i += 1) {
        text += event.results[i][0].transcript;
      }
      this.setInput(text);
      this.stopRecognition();
    };

    recognition.onend = () => {
      this.respond(messages.messageCouldntHear);
      this.stopRecognition();
    };
    recognition.start();
  };

  stopRecognition = () => {
    if (recognition) {
      recognition.stop();
      recognition = null;
    }
    this.updateRec();
  };

  updateRec = () => {
    recognition
      ? this.setState({ micImage: micDefault })
      : this.setState({ micImage: micImg });
  };

  setResponse = val => {
    const speech = JSON.parse(val);

    let d = botElement.innerHTML;
    botElement.innerHTML = `${d.replace(
      '',
      '',
    )}<div class='calloutbig'>
    <img src='${chatLogo}' width='45px' 
      height='45px' class='circular--square imgRight' style='float: left;' />
    <div class='calloutright'>${
      speech.result.fulfillment.speech
    }</div><div class='clear'></div></div>`;
    d = botElement.lastElementChild.innerHTML;
    botElement.lastElementChild.innerHTML = [
      d.slice(0, 24),
      '',
      d.slice(24),
    ].join('');

    botElement.scrollTop = botElement.scrollHeight;
  };

  setInput = text => {
    inputElement.value = text;
    this.send();
  };

  handleEnter(event) {
    if (event.which === 13) {
      event.preventDefault();
      this.send();
    }
  }

  respond = val => {
    if (val === '') {
      val = messages.messageSorry;
    }
    if (val !== messages.messageRecording) {
      const msg = new SpeechSynthesisUtterance();
      msg.voiceURI = 'native';
      msg.text = val;
      msg.lang = 'en-US';
      // msg.onend = () => {
      //   inputElement.value = "";
      // }
      window.speechSynthesis.speak(msg);
    }
  };

  render() {
    return (
      <div>
        <div
          className={`chatWrapper ${this.props.minimize ? 'botMinize' : ''}`}
        >
          <div className="chatLayout">
            <div className="chatHeader">
              <div className="small-2 float-left">
                {/* onClick={() => this.minimze()} */}
                {/* <img src={minimze} className="minizeChat" /> */}
                &nbsp;
              </div>
              <div
                className="small-8 float-left text-center pointer"
                onClick={() => this.props.toggleHidden()}
              >
                <div className="chatTitleText">Ask Simmons</div>
                <div className="subTextChat">Typically replies instantly</div>
              </div>
              <div className="small-2 float-left text-right">
                <img
                  src={closeX}
                  className="chatClose"
                  alt=""
                  onClick={() => this.props.closeChat()}
                />
              </div>
              <div className="clear" />
            </div>
            <div className="chatBoxLayout shadowright shadowleft shadowall">
              <div className="chatContent">
                <div
                  id="bot"
                  className="botclass"
                  ref={el => {
                    botElement = el;
                  }}
                />
              </div>
              <div className="console">
                <input
                  id="input"
                  type="text"
                  className="textin"
                  placeholder="Enter query..."
                  ref={el => {
                    inputElement = el;
                  }}
                />
                {/* <textarea></textarea> */}
                <button id="rec" className="speakRec" onClick={this.handleRec}>
                  <img src={this.state.micImage} alt="" />
                </button>
                <div className="chatSendImg pointer">
                  <img
                    src={sendImg}
                    alt=""
                    id="sendButton"
                    onClick={this.sendButonClick}
                  />
                </div>
                <div className="clear" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
